
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#0097a7","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"2"}},[_c('circle',{attrs:{"cx":"19.7","cy":"19.7","r":"6.7"}}),_c('path',{attrs:{"d":"M24.5 24.5L27 27"}})])])
          )
        }
      }
    